<script>
import { mapGetters } from 'vuex'
import { TabToStateMap } from "@views/products/enums/productStatusEnum";

export default {
  name: 'tabTitle',
  props: {
    label:   { type: String, required: true },
    tabKey:  { type: String, required: true }
  },
  computed: {
    ...mapGetters(['getFoundInStatuses']),

    foundStatusesOnly() {
      return this.getFoundInStatuses.map(item => item.status)
    },

    showTooltip() {
      const accepted = TabToStateMap[this.tabKey];
      const list = Array.isArray(accepted) ? accepted : [accepted];
      return this.foundStatusesOnly.some(s => list.includes(s));
    },

    tooltipLabel() {
      const accepted = TabToStateMap[this.tabKey];
      const list = Array.isArray(accepted) ? accepted : [accepted];
      const found = this.getFoundInStatuses.find(i => list.includes(i.status));
      return found ? `Busca encontrada: <b>${found.label}</b>` : 'Busca encontrada';
    }
  }
}
</script>

<template>
 <span>
    {{ label }}
    <span
        v-if="showTooltip"
        class="ml-1 text-info"
        v-b-tooltip.hover.html
        :title="tooltipLabel"
    >
      <i class="fas fa-info-circle"></i>
    </span>
  </span>
</template>

<style scoped lang="scss">
:deep(.tooltip-inner) {
  font-size: 13px !important;
  max-width: 100% !important;
}
</style>
